import { ACTION_TYPE } from '../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../core/redux/api/circuitBreaker/module';
import { apiGetFulfillmentSeasons } from '../core/redux/api/endpoints';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../core/redux/api/module';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../core/redux/IAppState';
import { assoc } from '../language/module';
import { FulfillmentSeason } from './models';

export const KEY_ACTION = ACTION_TYPE.GET_FULFILLMENT_SEASONS_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.GET_FULFILLMENT_SEASONS_REQUEST,
  ACTION_TYPE.GET_FULFILLMENT_SEASONS_RESPONSE,
  ACTION_TYPE.GET_FULFILLMENT_SEASONS_ERROR,
];


/**
 * An action to dispatch to get the list of fulfillment seasons
 */
export const getFulfillmentSeasonsAction = () => makeApiAction(
  {
    endpoint: apiGetFulfillmentSeasons(),
    method:   'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS as RsaaTypes,
    bailout:  state => !!getLoading(state, KEY_ACTION, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);

const reducer: ApiReducer<FulfillmentSeason[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  if (!payload){
    payload = [];
  }

  return assoc('fulfillmentSeasons', payload, noLoadingOrError);
};


export const getFulfillmentSeasonsReducer = makeApiReducer<FulfillmentSeason[]>(ACTIONS, KEY_ACTION, reducer);